import React, { useEffect, useState } from "react";
import ServerAPI from "../lib/server";
import Preloader from "../components/ui/Preloader";

// текстовые страницы
function UrlPage({ url }) {
  const [pageData, setPageData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    ServerAPI.customPostQuery(`/page_text?_=${Date.now()}`, { page: url })
      .then((res) => {
        console.log("res", res);
        setPageData(res || {});
      })
      .catch((err) => {
        console.log("err.message", err);
        setError(err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  if (loading) {
    return <Preloader />;
  }

  if (error) {
    return (
      <div className="min-h-screen bg-white flex items-center justify-center">
        <div className="text-center">
          <div className="text-red-500 text-lg mb-4">⚠️ {error}</div>
        </div>
      </div>
    );
  }

  return (
    <div
      className="p12"
      dangerouslySetInnerHTML={{ __html: pageData?.text || "" }}
    />
  );
}

export default UrlPage;
